{
  "pt": {
    "survey": {
      "actions": {
        "add": "Adicionar novo",
        "addDescription": "Adicionar descrição",
        "close": "Fechar",
        "create": "Criar",
        "createNew": "Novo",
        "delete": "Eliminar",
        "deleteCount": "Está prestes a eliminar {count} inquérito. Tem a certeza? | Está prestes a eliminar {count} inquéritos. Tem a certeza?",
        "deleteMultiple": "Eliminar...",
        "delete_cancel": "Cancelar",
        "delete_surveys": "Eliminar inquérito | Eliminar inquéritos",
        "importTemplate": "Importar",
        "newSurvey": "Inquérito",
        "publish": "Publicar",
        "publishCustomer": "Publicar para clientes",
        "revokeAccess": "Revogar o acesso",
        "save": "Guardar",
        "selectAll": "Selecionar todos os {total} inquéritos",
        "send": "Enviar",
        "sendCustomer": "Enviar ao cliente",
        "submit": "Enviar",
        "surveys_collapse": "Recolher inquéritos",
        "surveys_expand": "Expandir inquéritos",
        "unSelectAll": "Limpar seleção.",
        "unpublish": "Cancelar a publicação"
      },
      "attributes": {
        "description": "Título interno",
        "title": "A sua pergunta"
      },
      "labels": {
        "NPSOverview": "Visão geral do NPS",
        "NPSQuestion": "Qual é a probabilidade de recomendar a {name} a um amigo ou colega?",
        "addQuestion": "Pergunta",
        "allUnitsAssigned": "Todas as unidades atribuídas",
        "answerRequired": "Resposta (obrigatória)",
        "answer_later": "Responder mais tarde",
        "answeredAt": "Respondido em",
        "average_score": "Pontuação média",
        "clientTeam": "A equipa {name} ",
        "comments": "Comentários ou sugestões? (opcional)",
        "completedTime": "Respondido",
        "customer": "Cliente",
        "customer_status": "Estado",
        "detractors": "Detratores",
        "dissatisfied": "Insatisfeito",
        "extremelyLikely": "Extremamente provável",
        "lets_go": "Vamos lá",
        "list": "Lista",
        "mostRecentAnswers": "Respostas mais recentes",
        "neither_satisfied_nor_dissatisfied": "Nem satisfeito nem insatisfeito",
        "neutrals": "Neutros",
        "noAnswers": "Ainda não há respostas",
        "noSurveyFeedback": "Sem comentários ou sugestões",
        "noSurveysYet": "Ainda não há inquéritos. Crie o seu primeiro inquérito para começar.",
        "noUnitsClick": "Ainda não há unidades, clique aqui para adicionar",
        "no_opinion": "Sem opinião",
        "notAtAllLikely": "Não é de todo provável",
        "nps": "NPS",
        "numberAnswered": "{answered} de {total} respostas",
        "obligatory": "Tornar o inquérito obrigatório para os clientes",
        "pendingSurveys": " Precisamos do seu feedback",
        "promoters": "Promotores",
        "publishNow?": "Publicar agora?",
        "published": "Publicado",
        "publishedCount": "Publicar este inquérito ao cliente | Publicar {count} inquéritos aos clientes",
        "question": "Pergunta",
        "question_number": "Pergunta {current_number} de {total_questions}",
        "questions": "Perguntas",
        "respondents": "Nenhum inquirido | 1 inquirido | {count} inquiridos",
        "response": "Resposta",
        "responseTime": "Tempo de resposta",
        "responses": "Respostas",
        "revokeAccessCount": "Revogar o acesso a este inquérito para o cliente | Revogar o acesso a este inquérito para {count} clientes",
        "satisfied": "Satisfeito",
        "saveExplainer": "Tornar este inquérito visível para os seus clientes? Ou guardar e publicar mais tarde?",
        "scoreBreakdown": "Repartição da pontuação",
        "selectOneUnit": "Selecionar pelo menos 1 inquérito",
        "selectUnits": "Selecionar unidades",
        "selected": "{selected} inquérito está selecionado. | {selected} inquéritos estão selecionados.",
        "sendCount": "Enviar este inquérito ao cliente | Enviar inquéritos a {count} clientes",
        "sendExplainer": "Os seus clientes verão isto no seu painel de controlo",
        "sendNow?": "Enviar agora?",
        "sent": "Enviado",
        "sentCustomer": "Enviado ao cliente",
        "showSurveysFor": "Mostrar inquéritos para",
        "showingResultsFor": "A mostrar resultados para",
        "step0Title": "Que modelo de projeto e inquérito pretende utilizar?",
        "step2Subtitle": "Para que os seus clientes saibam qual é o objetivo deste inquérito",
        "step2Title": "Adicionar uma breve introdução",
        "step3Subtitle": "Selecione o seu projeto para incluir todas as suas unidades de uma só vez.",
        "step3Title": "Para que unidades gostaria de criar este inquérito?",
        "survey": "Inquérito",
        "surveyAlreadyAnswered": "O inquérito já foi respondido. Obrigado pelo seu feedback.",
        "surveyAnswer": "Comentário",
        "surveyNotCompleted": "O inquérito ainda não está concluído.",
        "surveys": "Inquéritos",
        "surveysCount": "{count} inquérito | {count} inquéritos",
        "surveys_all_projects": "Inquéritos de todos os projetos",
        "tabOverview": "Visão geral",
        "tabSurveys": "Inquéritos",
        "thankYou": "Obrigado pelo seu feedback!",
        "title": "Pergunta",
        "titles_must_be_unique": "Há perguntas duplicadas. As perguntas devem ser únicas!",
        "totalSelected": "Todos os {total} inquéritos estão selecionados.",
        "unanswered": "Sem resposta",
        "unit": "Unidade",
        "unitSelected": "Nenhuma unidade selecionada ainda | Uma unidade selecionada | {count} unidades selecionadas",
        "units": "Unidades",
        "unitsWithoutSurvey": "{count} unidade sem inquérito | {count} unidades sem inquérito",
        "unpublishedCount": "Cancelar a publicação deste inquérito | Cancelar a publicação de {count} inquéritos",
        "very_dissatisfied": "Muito insatisfeito",
        "very_satisfied": "Muito satisfeito",
        "visibility": "Visibilidade",
        "yourAnswers": "As suas respostas",
        "yourQuestion": "A sua pergunta"
      },
      "placeholders": {
        "employees": {
          "new": {
            "subtitle": "Peça feedback aos seus clientes",
            "title": "Criar o seu primeiro inquérito"
          },
          "none": {
            "subtitle": "Peça feedback aos seus clientes",
            "title": "Não foram encontrados inquéritos"
          }
        }
      },
      "toasts": {
        "bulk_create": "Inquérito criado com sucesso | Inquéritos criados com sucesso",
        "bulk_delete": "Inquérito eliminado com êxito | Inquéritos eliminados com êxito",
        "bulk_update": "Inquérito atualizado com sucesso | Inquéritos atualizados com sucesso",
        "update": "Inquérito atualizado com sucesso"
      },
      "validation": {
        "needName": "Introduzir uma pergunta",
        "needQuestion": "Adicionar pelo menos 1 pergunta",
        "selectUnit": "Selecionar pelo menos 1 unidade"
      }
    }
  }
}
